import { LOGS_SCHEMA_NAME } from '../api/logs'

export default {
  id  : `logs`,
  name: `Логи`,
  to  : `/${LOGS_SCHEMA_NAME}`,
  hide: () => true,
}
